import { formatReduxData } from '../components/Quiz/CreateQuiz/formatQuizData';
import QuizTypes from '../constants/quiz';
import quizService from '../services/quiz.service';

export const fetchQuizHistory = () => async dispatch => {
    try {
        const data = await quizService.GetHistory();
        dispatch({
            type: QuizTypes.SET_QUIZ_HISTORY,
            payload: data,
        });
    } catch (error) {
        console.error('Ошибка загрузки истории:', error);
    }
};

export const fetchQuizResult = (answers, quizId) => async dispatch => {
    try {
        const data = await quizService.GetResult(answers, quizId);

        dispatch({
            type: QuizTypes.SET_QUIZ_RESULT,
            payload: data,
        });
    } catch (error) {
        console.error('Ошибка загрузки результата квиза:', error);
    }
};

export const fetchActiveQuiz = quizId => async dispatch => {
    try {
        const data = await quizService.ActiveQuizzes(quizId);
        dispatch({
            type: QuizTypes.SET_ACTIVE_QUIZ,
            payload: data,
        });
    } catch (error) {
        console.error('Ошибка получения квиза', error);
    }
};

export const fetchGetQuizBoss = id => async dispatch => {
    try {
        const data = await quizService.GetQuizBoss(id);
        const updateQuizData = formatReduxData(data);
        dispatch({
            type: QuizTypes.SET_CREATE_QUIZ,
            payload: updateQuizData,
        });
    } catch (error) {
        console.error('Ошибка получения квиза босс:', error);
        throw error;
    }
};
